<template>
    <v-main>
      <div id="app">
      <div id="main-timeline">
      <div class="breadcrumbs">
        <button :class="$store.state.showTimeline ? 'breadcrumb-disabled breadcrumb-btn' : 'breadcrumb-home breadcrumb-btn'" v-bind:style= "[$store.state.showYearDetail ? {'box-shadow': '0px 8px 15px rgba(0, 0, 0, 0.3)'} : {'box-shadow': 'unset'}]" @click="scrollToTop(); $store.state.showTimeline = true; $store.state.showProfile = false; $store.state.showYearDetail = false;" aria-label="Go to main timeline">
            <img v-bind:src="require(`@/assets/ui/icon_breadcrumb_home.png`)" id="home-icon">
            <p>Timeline Home</p>
        </button>
        <button v-if="$store.state.showYearDetail" class="breadcrumb-current breadcrumb-btn">
            <p style="color: black"><span>{{ selectedDate }}</span></p>
        </button>
      </div>

      <div class="pop-up" v-show="this.showPop">
        <div class="pop-up-inner">
            <div class ="popup-header">
            <button class="close-btn"
                v-on:click="togglePop()">
                X
            </button>
            </div>
            <img v-bind:src="require(`@/assets/ui/${ currSlide }.png`)" id="pop-placeholder">
            <div class="btns">
              <button class="nav-btn" v-show="currSlide != 1"
                v-on:click="currSlide--">
                Prev
              </button>
              <button class="nav-btn" v-show="currSlide != 3"
                v-on:click="currSlide++">
                Next
              </button>
              <button class="nav-btn" v-show="currSlide == 3"
                v-on:click="togglePop">
                Begin
              </button>
              <br>
              <p style="color: #663333"> {{ currSlide }} / 3</p>
            </div>
        </div>
      </div>


       <div v-if="!$store.state.showYearDetail" class="filters" id="filters">
        <div class="filter-toggle2" id="desktop-toggle"></div>
        <button @click="toggleFilters()">
          <div class="filter-toggle2" id="mobile-toggle">
            <img v-bind:src="require(`@/assets/ui/search-tab_close_arrow.png`)" id="toggle-arrow">
          </div>
        </button>
        <form>
          <div class="search">
              <input type="text" v-model="searchEntry" placeholder="Search" aria-label="Type a search entry"/>
              <img v-bind:src="require(`@/assets/ui/icon_magnifying-glass.png`)" id="input-img">
          </div>
        </form>  

        
        <div class="filter-categories">
          <div class="separator"> Filters </div>
          <v-container id="filter">
            <v-col><v-overflow-btn 
              class="filter-input"
              :items="dropdown_date"
              label="Date"
              v-model="selectedDateHolder"
              dense
              hide-details
              target="#filter"
              aria-label="Select a date to filter by"
            ></v-overflow-btn>
            <v-overflow-btn 
              class="filter-input"
              :items="dropdown_location"
              label="Location"
              v-model="selectedLocationHolder"
              dense
              hide-details
              target="#filter"
              aria-label="Select a location to filter by"
            ></v-overflow-btn></v-col>
            <v-col><v-overflow-btn 
              class="filter-input"
              :items="dropdown_topic"
              label="Topic"
              v-model="selectedTopicHolder"
              dense
              hide-details
              target="#filter"
              aria-label="Select a topic to filter by"
            ></v-overflow-btn>
            <v-overflow-btn 
              class="filter-input"
              :items="dropdown_person"
              label="Person"
              v-model="selectedPersonHolder"
              dense
              hide-details
              target="#filter"
              aria-label="Select a person to filter by"
            ></v-overflow-btn></v-col>
          </v-container>
          <!-- <br> -->
          <label id="alert" style="text-align: center;" v-if="showAlert">No events with this filter.</label>
          <div class="bottom-btns">
            <button class="filter-button" @click="clearFilters(); clearHolders(); showTubmanEvents = false; showDouglassEvents = false; collapse()" aria-label="Clear all filters">
              Clear filters
            </button>
            <button class="filter-button" @click="search()" aria-label="Click to filter the timeline">
              Search
            </button>
            <br>
          </div>
          <div class="center-btn">
            <button class="glossary-btn filter-button" aria-label="Go to glossary page" @click="showGlossaryScreen()">
              Glossary
            </button>
          </div>
        </div>
      </div>

      <div class="btn-container" v-if="!$store.state.showYearDetail">
            <button class="btn-group" v-if="!reverse"  @click="reverseChronological()">
              <img class="ui-btn" v-bind:src="require(`@/assets/ui/button_reverse-timeline_01.png`)" aria-label="Reverse the chronological order of the timeline">
            </button>
            <button class="btn-group" v-if="reverse"  @click="reverseChronological()">
              <img class="ui-btn" v-bind:src="require(`@/assets/ui/button_reverse-timeline_02.png`)" aria-label="Reverse the chronological order of the timeline">
            </button>
            <button class="btn-group" id="zoom-out" v-if="zoomedIn" @click="zoomView()">
              <img class="ui-btn" v-bind:src="require(`@/assets/ui/button_zoomout.png`)" aria-label="Reverse the chronological order of the timeline">
            </button>
            <button class="btn-group" id="zoom-in" v-if="!zoomedIn"  @click="zoomView()">
              <img class="ui-btn" v-bind:src="require(`@/assets/ui/button_zoomin.png`)" aria-label="Reverse the chronological order of the timeline">
            </button>
            <button class="btn-group" id="revertBtn" @click="clearFilters(); clearHolders(); disableBtn(false); showTubmanEvents = false; showDouglassEvents = false; collapse()">
                <img class="ui-btn" v-bind:src="require(`@/assets/ui/button_revert-to-full-timeline.png`)" aria-label="Revert to the full timeline">
            </button>

      </div>

        <div class="full-timeline"> 
          <v-timeline 
            :align-top=true
            dense
          >
          
          <div class="vert-line"></div>

          <div class="timeline-elt" 
              v-for="(event, i) in events"
              :key="i"
              ref="cards"
              v-bind:id="'elt-' + i"
          >

              <v-timeline-item
                small
                color="#4c4337"
                v-show="searchFor(events[i], i) && filterResult(events[i], i)"
                >

              <v-card 
                class="rounded-xl elt" 
                v-bind:id="'card-'+i"
                max-width="601"
                min-width="550"
                shaped
                flat
                color="#535353"
                elevation="0"
              >
              
              <img class="dots" v-bind:id="'dots-' + i" v-bind:src="require(`@/assets/ui/dots.png`)">
              <img class="active-dot-small" v-if="!isHighlight(events[i])" v-bind:id="'active-dot-' + i" v-bind:src="require(`@/assets/ui/circle_active.png`)">
              <img style="width:55px; height: auto" class="active-dot-big" v-if="isHighlight(events[i])" v-bind:id="'active-dot-' + i" v-bind:src="require(`@/assets/ui/circle_active_large.png`)">

              <div class="vert-line-highlight" v-bind:id="'vert-line-highlight-' + i" style="display:none"></div>
              <div class="overlay" v-bind:id="'overlay-' + i" style="display:block"></div>
              <div class="circle" v-bind:id="'circle-' + i" v-if="isHighlight(events[i])"></div>

                <v-card-text>
                  <div class="timeline-card">
                    
                    <div class="profile-icon-container">
                      <h1>{{ events[i].year }} </h1>
                  <div class="profile-icon-group" v-show="events[i].importantPeopleAssociates" v-for="(n, j) in events[i].importantPeopleAssociates" :key="j">
                    <button v-if="events[i].importantPeopleAssociates" @click="showProfileScreen(events[i].importantPeopleAssociates[j])" >
                      <img class="profile-icon" v-bind:src="require(`@/assets/art/icon-photos/${ getFileName(events[i].importantPeopleAssociates[j]) }.png`)" v-bind:alt="`Photo of ${events[i].importantPeopleAssociates[j]}`" v-bind:aria-label="`Go to ${events[i].importantPeopleAssociates[j]}'s profile page`">
                    </button>
                  </div>
                  </div>
                  <div class="source-thumbnail-button" v-if="primarySourceExists(events[i])" >
                   <button  @click="showPrimarySourceScreen(events[i].affiliatedPrimarySourcesNameAndDescription, events[i].affiliatedPrimarySourcesLink, events[i].id)"><img class="sourceThumbnail" :class="getThumbStyles(events[i].id)" v-if="events[i].affiliatedPrimarySourcesNameAndDescription" v-bind:src="require(`@/assets/art/primary-source-photos/${ events[i].sourceThumbnail }`)" v-bind:alt="`${events[i].affiliatedPrimarySourcesNameAndDescription}`"  v-bind:aria-label="`Take a closer look at ${events[i].affiliatedPrimarySourcesNameAndDescription}`"></button>
                 </div>
                 
                 <h1 v-if="events[i].title">{{events[i].title}}</h1>
                 

                  <p v-html="events[i].event"></p>
                 
                  <div class="details">
                    <button v-if="events[i].location" class="location" @click="filterLocation(events[i].location); disableBtn(true)"><p class="sub-text" v-bind:aria-label="`Filter the timeline to view ${events[i].location} content`"><span style="color: #d5ca9a">Location: </span>{{ events[i].location }}</p></button>
                    <button v-if="events[i].topics" class="topics" @click="filterTopics(events[i].topics); disableBtn(true)"><p class="sub-text" v-bind:aria-label="`Filter the timeline to view ${events[i].topics} content`"><span style="color: #d5ca9a">Topics: </span>{{ events[i].topics }}</p></button>
                  </div>
                  </div>
                </v-card-text>
              </v-card>
              </v-timeline-item>
            </div>
            </v-timeline>
          </div>
        </div>
      </div>
    </v-main>
</template>

<script>
  import data from '@/content/content.js';
  import psData from '@/content/primarySources.js'

  export default {
    name: 'Timeline',

    created () {
      window.addEventListener('scroll', this.highlightCard);
      window.addEventListener('load', this.highlightCard);
      window.addEventListener('load', this.clearFilters);
      window.addEventListener('load', this.clearHolders);
      this.togglePop();
    },
    destroyed () {
      window.removeEventListener('scroll', this.highlightCard);
    },

    computed: {

    },

    methods: {
      isHighlight(tlEvent) {
        /*
        var rtn = false;
        var people = tlEvent.importantPeopleAssociates;

        if(people) {
          if( people.includes("Harriet Tubman") || people.includes("Frederick Douglass") ) {
            rtn = true;
          }
        }

        return rtn;*/
        return tlEvent.highlighted
      },
      scrollToTop() {
        if(this.$store.state.showTimeline == true)
        {
          window.scroll({
            top: 0, 
            behavior: 'smooth'
          });
        }
      },
      showGlossaryScreen(){
        this.saveScrollPos();
        this.$store.state.showGlossary = true;
        this.$store.state.showTimeline = false;
        this.$store.state.showProfile = false;
        this.$store.state.showYearDetail = false;
        this.$store.state.showMap = false;
        this.$store.state.showPrimarySource = false;
      },
      showTimelineScreen() {
        this.$store.state.showTimeline = true;
        this.$store.state.showProfile = false;
        this.$store.state.showYearDetail = false;
        this.$store.state.showGlossary = false;
        this.$store.state.showMap = false;
        this.$store.state.showPrimarySource = false;
      },
      showMapScreen(year, id,hideMap){
        if(hideMap){return;}
        this.saveScrollPos();
        this.$store.state.mapYear = year;
        this.$store.state.mapEventId = id;
        this.$store.state.showMap = true;
        this.$store.state.showTimeline = false;
        this.$store.state.showProfile = false;
        this.$store.state.showYearDetail = false;
        this.$store.state.showGlossary = false;
        this.$store.state.showPrimarySource = false;
      },
      showPrimarySourceScreen(source, link, id){
        this.saveScrollPos();
        this.$store.state.currSource = source;
        this.$store.state.currSourceLink = link;
        this.$store.state.currSourceId = id;
        this.$store.state.showPrimarySource = true;
        this.$store.state.showMap = false;
        this.$store.state.showTimeline = false;
        this.$store.state.showProfile = false;
        this.$store.state.showYearDetail = false;
        this.$store.state.showGlossary = false;
      },
      showProfileScreen(name) {
        this.saveScrollPos();
        this.$store.state.currPerson = name;
        //console.log(this.$store.state.currPerson)
        this.$store.state.showProfile = true;
        this.$store.state.showTimeline = false;
        this.$store.state.showYearDetail = false;
        this.$store.state.showGlossary = false;
        this.$store.state.showMap = false;
        this.$store.state.showPrimarySource = false;
      },
      showYearDetailScreen(year) {
        this.saveScrollPos();
        this.$store.state.currYear = year;
        this.$store.state.showYearDetail = true;
        this.$store.state.showTimeline = false;
        this.$store.state.showProfile = false;
        this.$store.state.showGlossary = false;
        this.$store.state.showMap = false;
      },
      switchProfile(newPerson){
        this.$store.state.currPerson = newPerson;
      },
      primarySourceExists(event) {
        return event.affiliatedPrimarySourcesNameAndDescription != "N/A";
      },
      primaryIsVideo(event) {
        if( event.affiliatedPrimarySourcesLink ) {
          var firstSeven = event.affiliatedPrimarySourcesLink.slice(0,7);
          return firstSeven == "<iframe";
        } else {
          return false;
        }
      },
      togglePop() {
        this.showPop = !this.showPop;
      },
      toggleFilters() {
        this.showFilters = !this.showFilters;
        if(!this.showFilters)
        {
          document.getElementById('filters').style.bottom = '-53.2%';
          document.getElementById('toggle-arrow').style.transform = 'scaleY(-1)';

        }
        else {
          document.getElementById('filters').style.bottom = '0';
          document.getElementById('toggle-arrow').style.transform = 'scaleY(1)';
        }
      },
      getFileName(name){
        var icon = name;
        icon = icon.replace(/\s+/g, '-').toLowerCase();
        return icon;
      },
      getPrimarySourceThumb(id) {
        let file = this.primarySources.find(item => item.id === id);
        return file ? file.image : "placeholder";
      },
      getThumbStyles(id) {
        let evt = this.events.find(item => item.id === id);
        return evt.centerThumbnail ? "center-thumbnail" : "";
      },
      saveScrollPos(){
        if(this.$store.state.showTimeline == true && this.userScroll)
        {
          localStorage.clear();
          localStorage.setItem('currEventId', this.currEvent.id);
        }
      },
      isElementInViewport(el) {
        var rect = el.getBoundingClientRect();

        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight * 2 || document.documentElement.clientHeight * 2) && 
          rect.right <= (window.innerWidth * 2 || document.documentElement.clientWidth * 2) 
        );
      },
      /**
      move the yellow highlight to topmost event as the user scrolls
      */
      highlightCard(){
        this.displayedEvents.length = 0;

        for (let i = 0; i < this.timelineElts.length; i ++)
        {
          if(this.timelineElts[i].style.display == 'block' && this.timelineElts[i].children[0].style.display !== 'none'){
            this.displayedEvents.push(this.timelineElts[i]);
          }
        }
        
        for (let i = 0; i < this.displayedEvents.length; i++)
        {
          let nextelem = this.displayedEvents[i + 1] || this.displayedEvents[i];
          let nextcard = nextelem.children[0].children[0].children[0];
          let nextdots = nextelem.children[0].children[0].children[0].children[0];
          let nextactiveDot = nextelem.children[0].children[0].children[0].children[1];
          let nextactiveLine = nextelem.children[0].children[0].children[0].children[2];
          let nextoverlay = nextelem.children[0].children[0].children[0].children[3];

          let elem = this.displayedEvents[i];
          let card = elem.children[0].children[0].children[0];
          let dots = elem.children[0].children[0].children[0].children[0];
          let activeDot = elem.children[0].children[0].children[0].children[1];
          let activeLine = elem.children[0].children[0].children[0].children[2];
          let overlay = elem.children[0].children[0].children[0].children[3];
          let circle = elem.children[0].children[0].children[0].children[4];
          circle = (circle.id.includes("circle")) ? circle : 0;

          let lastEvent = this.currEvent;

            if(this.isElementInViewport(card))
            {
              this.currEvent = elem;
              if((this.currEvent != lastEvent) || i == 0)
              {
                //remove highlight for lower events when scrolling up
                if(nextelem) 
                {
                  nextactiveLine.style.display = "none";
                  nextcard.style.border = 'unset';
                  nextdots.style.display = "none";
                  nextactiveDot.style.display = "none";
                  nextcard.style.background = '#535353';
                  nextoverlay.style.display = "block";
                  if(circle != 0) { circle.style.visibility = "visible"}
                }
                else{
                  break;
                }
                activeLine.style.display = "block";
                card.style.border = '5px solid #c5bb90';
                card.style.background = "#535353";
                dots.style.display = "block";
                activeDot.style.display = "block";
                overlay.style.display = "none";
                this.activeDotPos = activeDot.getBoundingClientRect().top;
                if(circle != 0) { circle.style.visibility = "hidden"}
                if(typeof this.hiddenDot.style !== 'undefined') {this.hiddenDot.style.visibility = "visible"}
                break;
              }
              else if (this.currEvent == lastEvent)
              {
                break;
              }
            }
            else {
              activeLine.style.display = "none";
              card.style.border = 'unset';
              dots.style.display = "none";
              activeDot.style.display = "none";
              card.style.background = '#535353';
              overlay.style.display = "block";
              if(circle != 0) { circle.style.visibility = "visible"}
            }
        }

        // remove any preexisting highlights
        for (let i = 0; i < this.displayedEvents.length; i++)
        {
          let elem = this.displayedEvents[i];
          let card = elem.children[0].children[0].children[0];
          let dots = elem.children[0].children[0].children[0].children[0];
          let activeDot = elem.children[0].children[0].children[0].children[1];
          let activeLine = elem.children[0].children[0].children[0].children[2];
          let overlay = elem.children[0].children[0].children[0].children[3];
          let circle = elem.children[0].children[0].children[0].children[4];
          circle = (circle.id.includes("circle")) ? circle : 0;

              if(elem != this.currEvent)
              {
                activeLine.style.display = "none";
                card.style.border = 'unset';
                dots.style.display = "none";
                activeDot.style.display = "none";
                card.style.background = '#535353';
                overlay.style.display = "block";
                if(circle != 0) { circle.style.visibility = "visible"}
            }
        }
      },

      /**
      filter timeline items based on search string
      */
      searchFor(item, index)
      {
          if(!this.searchString)
          {
            return true;
          }

          this.disableBtn(true);
          this.searchString = this.searchString.trim().toLowerCase();
          var itemDesc = item.event;

          if(!this.$store.state.showYearDetail)
          {
            if(index == this.events.length - 1)
            {
              this.fillTimeline(true);
            }
          }

          var count = 0;

          if(itemDesc !== undefined){
          var itemLowercase = itemDesc.toLowerCase();
            if(itemLowercase.includes(this.searchString))
            {
              count++;
            }
        }

        if(count > 0)
        {
          this.included = true;
          this.timelineElts[index].style.display = 'block';
          return true;
        }
        else{
          this.timelineElts[index].style.display = 'none';
        }
      },
      /**
      filter timeline items based on selected filters
      */
      filterResult(item, index){

        if(this.$store.state.showYearDetail){
          this.selectedDate = this.$store.state.currYear;
          this.selectedTopic = "";
          this.selectedPerson = ""; 
          this.selectedLocation = "";
        }

        if(!this.selectedTopic && !this.selectedPerson && !this.selectedLocation && !this.selectedDate)
        {
          return true;
        }

        this.disableBtn(true);

        var items = [item.topics, item.importantPeopleAssociates, item.broaderLoc, item.year];
        var itemsSelected = [this.selectedTopic, this.selectedPerson, this.selectedLocation, this.selectedDate];

        if(index == this.events.length - 1)
        {
          this.fillTimeline(true);
        }

        var matches = 0;
        for(var i = 0; i < items.length; i++)
        {
          if(items[i] !== undefined)
          {
            if(itemsSelected[i] !== "")
            {
              items[i] = items[i].toString();
              if(items[i].includes(itemsSelected[i]))
              {
                matches++;
              }
            }
          }
        }
        
        var filtersOn = 0;
        for (let i = 0; i < itemsSelected.length; i++)
        {
          if(itemsSelected[i] !== "")
          {
            filtersOn++;
          }
        }
        
        if(matches == filtersOn)
        {
          this.timelineElts[index].style.display = 'block';
          this.filtersIncluded = true;
          return true;
        }
        else {
          this.timelineElts[index].style.display = 'none';
        }
      },
      /** 
      Filter timeline to display events regarding topic clicked
      */
      filterTopics(topicsText){
        const topicArray = topicsText.split(', ');
        for (let i = 0; i < topicArray.length; i++)
        {
          this.selectedTopic = topicArray[i];
        }
      },
      /**
      display full timeline when filters are invalid
      */
      fillTimeline(fromFilter){
        if(fromFilter)
        {
          if((this.searchString != "" && this.selectedDate != "") 
            && (this.included || !this.filtersIncluded)){
            this.clearFilters();
            this.showAlert = true;
          }
          else if(!this.included && !this.filtersIncluded)
          {
            this.clearFilters();
            this.showAlert = true;
            return;
          } 
          else if(this.included && this.filtersIncluded){
            return;
          }
          else if(this.included && this.selectedDate == "" && this.selectedLocation == "" 
            && this.selectedTopic == "" && this.selectedPerson == "")
          {
            return;
          }
          else if(!this.included && (this.selectedDate !== "" || this.selectedLocation !== "" || this.selectedTopic !== "" || this.selectedPerson !== ""))
          {
            return;
          }
          else{
            this.clearFilters();
            this.showAlert = true;
          }
        }
        else{
          this.clearFilters();
          // this.showAlert = true;
          window.scrollTo(0,1000);
          window.scrollTo(0,0);
        }
        
      },
      /** 
      reverse the chronological order of the timeline
      */
      reverseChronological(){
        this.events = this.events.reverse();
        this.reverse = !this.reverse;
        // console.log('reverse', this.reverse)

        localStorage.setItem('inOrder', this.reverse);
      },
      /** 
      inOrder is true if events are set in chronological order 
      */
      setChronological() {
        const inOrder = localStorage.getItem('inOrder');
        // console.log('order', inOrder)
        if(inOrder) {
          this.events = this.events.reverse();
        }
      },
      /**
      Toggle between zoomed in/out view of timeline
      */
      zoomView(){
        const timeline = document.getElementsByClassName('full-timeline');
        for(var i = 0; i < timeline.length; i++)
        {
          if(this.zoomedIn)
          {
            timeline[i].classList.add('zoomed');
            this.zoomedIn = false;
          }
          else {
            timeline[i].classList.remove('zoomed');
            this.zoomedIn = true;
          }
        }

        this.currEvent.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });  

        localStorage.setItem('zoom', this.zoomedIn);
        // console.log(localStorage)
      }, 
      /** 
      build arrays for each field's dropdown
      */
      getFilterOptions(){
        var topicArray = [];
        for(let i = 0; i < this.events.length; i++)
        {
          if(this.events[i].year !== undefined)
            this.dropdown_date.push(this.events[i].year);
          if(this.events[i].topics !== undefined){
            topicArray = this.events[i].topics.split(', ');
            for (let j = 0; j < topicArray.length; j++)
            {
              if(!this.dropdown_topic.includes(topicArray[j]))
              {
                this.dropdown_topic.push(topicArray[j]);
              }
            }
          }
          if(this.events[i].broaderLoc !== undefined)
          {
            for (let j = 0; j < this.events[i].broaderLoc.length; j ++){
              if(!this.dropdown_location.includes(this.events[i].broaderLoc[j]))
                this.dropdown_location.push(this.events[i].broaderLoc[j]);
            }
          }
          if(this.events[i].importantPeopleAssociates !== undefined)
          {
            for (let j = 0; j < this.events[i].importantPeopleAssociates.length; j ++){
              if(!this.dropdown_person.includes(this.events[i].importantPeopleAssociates[j]))
                this.dropdown_person.push(this.events[i].importantPeopleAssociates[j]);
            }
          }
        }
      },
      disableBtn(disable){
        if(!this.$store.state.showYearDetail)
          document.getElementById('revertBtn').style.opacity = disable ? "100%" : "20%";
      },
      /** 
      Activate the variables for the search entry and filters
      */
      search(){

        this.collapse();


        this.showAlert = false;
        this.included = false;
        this.filtersIncluded = false;

        this.searchString = this.searchEntry;

        this.selectedDate = this.selectedDateHolder;
        this.selectedLocation = this.selectedLocationHolder;
        this.selectedTopic = this.selectedTopicHolder;
        this.selectedPerson = this.selectedPersonHolder;

        this.$filterStore = [this.selectedTopic, this.selectedPerson, this.selectedLocation, this.selectedDate];


        window.scrollTo(0,1000);
        window.scrollTo(0,0);

        this.highlightCard();


      },
      clearFilters(){
        for(let i = 0; i < this.timelineElts.length; i++)
        {
          this.timelineElts[i].style.display = 'block';
        }

        if(this.showAlert){
          this.clearHolders();
        }

        this.selectedDate = ""; 
        this.selectedLocation = "";
        this.selectedTopic = "";
        this.selectedPerson = "";
        this.searchString = "";

        this.searches = [];
        this.showAlert = false;
        this.included = false;
        this.filtersIncluded = false;

        this.disableBtn(false);
      },
      clearHolders(){
        this.selectedDateHolder = ""; 
        this.selectedLocationHolder = "";
        this.selectedTopicHolder = "";
        this.selectedPersonHolder = "";
        this.searchEntry = "";
      },
      /**
      collapse or expand timeline to show just Tubman/Douglass-related events, or all events
      */
      collapse()
      {
        let currentlyDisplayed = 0;
        

        for (let i = 0; i < this.timelineElts.length; i++)
        {
          let elem = this.timelineElts[i];

          elem.style.display = "block";

          

          if(this.isElementInViewport(elem)){
            currentlyDisplayed++;
          }
        }

        if(currentlyDisplayed === this.$refs.cards.length) {
          this.fillTimeline(false);
        }

        this.currEvent.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });  
      },
      GetCookie(name) {
        var arg=name+"=";
        var alen=arg.length;
        var clen=document.cookie.length;
        var i=0;
        while (i<clen) {
        var j=i+alen;
        if (document.cookie.substring(i,j)==arg)
          return "here";
        i=document.cookie.indexOf(" ",i)+1;
        if (i==0) break;
        }
        return null;
      },
      testFirstCookie(){
        var visit=this.GetCookie("FirstTimeVisitCookie");
        if (visit==null){
           var expire=new Date();
           expire=new Date(expire.getTime()+7776000000);
           document.cookie="FirstTimeVisitCookie=here; expires="+expire + ";path=/";
           this.showPop = true;
         } else {
           this.showPop = false;
         }
      },
      offset(el) {
        var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
      }

    },

    mounted() {
      this.testFirstCookie();
      this.getFilterOptions();
      this.setChronological();
      if(window.innerWidth < 1200) this.toggleFilters();

      let currEventId = localStorage.getItem('currEventId');
      let currEventCard = document.getElementById(currEventId);
      this.currEvent = currEventId ? currEventCard : this.$refs.cards[0];

      for(let i = 0; i < this.timelineElts.length; i++)
      {
        this.timelineElts[i].style.display = 'block';
      }

      if(!this.$store.state.showYearDetail)
      {
        this.collapse();
        this.disableBtn(false);
      }

      // Return to previous state of timeline
      if(currEventId){
        let zoom = localStorage.getItem('zoom');
        let currEventPos = this.offset(currEventCard);
        let scrollY = currEventPos.top;
        var num = currEventId.substr(-1);
        let dotId = "active-dot-" + num;

        // persistent zoom
        if(zoom == 'false') {
          document.getElementById('zoom-out').click();
        }

        // scroll to current event upon return
        if(this.zoomedIn) {
          scrollY = currEventPos.top - 50;
        }
        else {
          scrollY = currEventPos.top - 300;
        }
        window.scrollTo(0, scrollY);

        // TODO: temporarily hiding the big dot 
        this.hiddenDot = document.getElementById(dotId);
        this.hiddenDot.style.visibility = "hidden";
      }
      else {
        window.scrollTo(0, 1000);
        window.scrollTo(0, 0);
      }
    },

    watch:{

    },

    data() {
      return{
        id: null,
          drawer: null,
          showPop: false,
          showFilters: true,
          currSlide: 1,
          userScroll: true,
          included: false,
          filtersIncluded: false,
          activeDotPos: 0,
          reverse: true,
          zoomedIn: true,
          currEvent: null,
          displayedEvents: [],
          timelineElts: document.getElementsByClassName('timeline-elt'),

          items: [
        { title: 'Home', icon: 'mdi-view-dashboard' },
        { title: 'About', icon: 'mdi-forum' },
          ],

          searchString : "",
          searchEntry : "",
          showTubmanEvents: false,
          showDouglassEvents: false,
          showAlert: false,
          showProfile: false,
          events: data.events.sort(function(a,b){return a.yearSort-b.yearSort}),
          primarySources: psData.sources,

          selectedDate: "",
          selectedLocation: "",
          selectedTopic: "",
          selectedPerson: "",
          selectedDateHolder: "",
          selectedLocationHolder: "",
          selectedTopicHolder: "",
          selectedPersonHolder: "",
          searches: [],
          dropdown_location: [],
          dropdown_person: [],
          dropdown_topic: [],
          dropdown_date: [],
          hiddenDot: {}
      }
    }
  }
</script>

<style type="text/css">
  @import "../assets/styles/timeline-style.css";
</style>
